module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James Riley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("James Riley lives in Virginia. He is the "), _c('I', [_vm._v("New York Times ")]), _vm._v("bestselling author of the Half Upon a Time, Story Thieves, Revenge of Magic, and Once Upon Another Time series.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/173Gqk6/tc-custom/9781534425866.jpg?1730494641556",
      "alt": "This image is the cover for the book Chosen One, The Revenge of Magic"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Chosen One, The Revenge of Magic\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Fort and his friends face more perilous ancient magic as they race towards a battle to save humanity in this fifth and final installment in the fantastical series from the author of the "), _c('i', [_vm._v("New York Times")]), _vm._v(" bestselling "), _c('i', [_vm._v("Story Thieves")]), _vm._v("!")]), _c('br'), _c('br'), _vm._v("Fort Fitzgerald is finally reunited with his father and wants nothing more than for life to return to normal, the way things were before magic burst back into the world. But normal isn’t an option anymore. Not when the Old Ones could still return to enslave humanity and Damian is dead set on making that happen. "), _c('br'), _c('br'), _vm._v("Convinced he’s the Chosen One the prophecy says will save the world, Damian has mastered all six books of magic and plans to summon the Old Ones to destroy them. Fort knows better though—Damian has no chance of defeating the Old Ones once they arrive. "), _c('br'), _c('br'), _vm._v("Maybe Fort could stop Damian if he could use the magic from the dragon dictionary, but he’s consumed with strange visions each time he tries. The only hope left is for Fort, Jia, and Rachel to recruit the help of old friends—and enemies. But how can they know who to trust? Because unless they can find the truth behind the web of secrets and lies surrounding the prophecy of the Chosen One, Fort’s visions, Arthurian legends, and even magic itself, they’ve already lost.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Aladdin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0